// extracted by mini-css-extract-plugin
module.exports = {"textIconCell":"TextIconCell_textIconCell__HL0ND"};